$(document).ready(function(){
     $('.popup-team-block-header-definig').addClass('active');
     $(".view-spec-accordion").click(function(){
      $(this).parent('.mobile-neck_desc').find('.panel').slideToggle(300);
     $(this).parent('.mobile-neck_desc').find('.panel').toggleClass('show-specific');
  }); 
    $(".mob-view-spec-accordion").click(function(){
     $(this).parent('.mobile-neck_desc').find('.panel').slideToggle(400);
     $(this).parent('.mobile-neck_desc').find('.panel').toggleClass('show-specific');
     $(this).find('.view-spec-icon').toggleClass('active');
  }); 
   //meet steam secttion
 $('.meet-team-plus-icon').click(function(){
      $(this).parents('.meet-team-inner').addClass('popup-active');
      $('body').addClass('body-masked');
    });
  $(".team-plus-icon-outer").click(function(){
      $(this).parents('.meet-team-inner').find('.popup-team-block-section').toggleClass('hide');
      $(this).toggleClass("popup-mobile");
  });
  $('.team-close').click(function(){
    $(this).parents('.meet-team-inner').removeClass('popup-active');
    $('body').removeClass('body-masked')
  });
  $(".popup-team-block-header-definig").click(function(){
    $(this).addClass('active');
      $(this).parents('.popup-team-block-header').find('.popup-team-block-header-right').removeClass('active');
    $(this).parents('.popup_inner_team_box').find('.inner_team-first').addClass('active-tab');
    $(this).parents('.popup_inner_team_box').find('.inner_team-second').removeClass('active-tab');
    }); 
  $(".popup-team-block-header-right").click(function(){
    $(this).addClass('active');
       $(this).parents('.popup-team-block-header').find('.popup-team-block-header-definig').removeClass('active');
    $(this).parents('.popup_inner_team_box').find('.inner_team-second').addClass('active-tab');
    $(this).parents('.popup_inner_team_box').find('.inner_team-first').removeClass('active-tab');
  }); 
  // testimonial form popup
  $(".write-testimonial-form-btn").click(function(){
     $('.popup-testimonial-form').removeClass('hidden');
    $('body').addClass('testimonial-popup');
    }); 
  $(".testimonial-form-close").click(function(){
    $('.popup-testimonial-form').addClass('hidden');
      $('body').removeClass('testimonial-popup');
  }); 
   $(".order-list-write-review").click(function(){
       var productTitle = $(this).closest('.account-order-list-inner').find('.account-product-title').attr('productname');
      $("#product_name").val(productTitle);
    });
});


document.addEventListener('DOMContentLoaded', function () {
  const observer = new MutationObserver(function (mutationsList) {
    mutationsList.forEach(function (mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
        const target = mutation.target;
        if (target.classList.contains('mobile-facets__disclosure')) {
          if (target.hasAttribute('open')) {
            document.body.classList.add('filter_overflow_hidden');
          } else {
            document.body.classList.remove('filter_overflow_hidden');
          }
        }
      }
    });
  });

  // Observe all elements with .mobile-facets__disclosure
  const facets = document.querySelectorAll('.mobile-facets__disclosure');
  facets.forEach(function (facet) {
    observer.observe(facet, { attributes: true });
  });
});


	
// Equal Height Js
function equl(name) {
  let heading = document.querySelectorAll(name);
  let titleHeight = 0;
  heading.forEach((title) => {
    let matchHeight = title.clientHeight;
    if (matchHeight > titleHeight) {
      titleHeight = title.clientHeight;
    }
  });
  heading.forEach((divHeight) => {
    divHeight.style.minHeight = titleHeight + "px";
  });
}
document.addEventListener("DOMContentLoaded", function (event) {
  setTimeout(() => {
    equl(".product-card-brand-modal a");
    equl(".meet-the-team-image img");
    equl(".swym-title");
    equl('.main-home-recently-view .card-information');
  }, 500);
});


function cleanProductDescription() {
  const descElements = document.querySelectorAll(".product_card_short_description");

  descElements.forEach(function (desc) {
    if (desc.innerHTML) {
      desc.innerHTML = desc.innerHTML.replace(/(\s*<br\s*\/?>\s*){2,}/gi, "<br>");
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  cleanProductDescription();

  setTimeout(cleanProductDescription, 1000);
  setTimeout(cleanProductDescription, 3000);
});

document.addEventListener("boost:facets:updated", function () {
  cleanProductDescription();
  setTimeout(cleanProductDescription, 1000);
});



document.addEventListener("DOMContentLoaded", function () {
  const headerIcon = document.querySelector(".header-cart-section");

  if (headerIcon) {
    headerIcon.addEventListener("click", function (e) {
      if (window.location.pathname === "/cart") {
        e.preventDefault();
        e.stopImmediatePropagation();
        window.location.href = "/";
      }
    }, true);
  }

    const descDiv = document.querySelector(".product-accordion-desc");
  if (!descDiv) return;

  Array.from(descDiv.childNodes).forEach(node => {
    // Text node che ane h2 nathi
    if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== "") {
      const p = document.createElement("p");
      p.textContent = node.textContent.trim();
      descDiv.insertBefore(p, node);
      descDiv.removeChild(node);
    }
  });
});


// -------------------------------
// DEFAULT ACTIVE (ReBuy loads late - fix using interval)
// -------------------------------
function activateFreeGiftSection() {
  const titleEl = document.querySelector(".rebuy-cart__progress-free-products-title");
  const listEl = document.querySelector(".rebuy-cart__progress-free-products-list");

  if (titleEl && listEl) {
    titleEl.classList.add("active");
    listEl.classList.add("active");
    return true;
  }
  return false;
}

// Retry until ReBuy elements appear
const activeInterval = setInterval(() => {
  if (activateFreeGiftSection()) {
    clearInterval(activeInterval);
  }
}, 300);



document.addEventListener("click", function (e) {
  const title = e.target.closest(".rebuy-cart__progress-free-products-title");
  if (!title) return;

  const list = document.querySelector(".rebuy-cart__progress-free-products-list");
  if (!list) return;

  // Toggle
  title.classList.toggle("active");
  list.classList.toggle("active");
});




